import { type StaticImageData } from 'next/image'
import { useTheme } from 'styled-components'

import { ImageCustom } from '@/components/shared/image'
import { LowOrZeroResultsBannerContainer } from '@/components/srp/low-or-zero-results/styled'
import { BodyText } from '@/ui/atoms/body-text/BodyText'
import { Flex } from '@/ui/atoms/flex/Flex'
import { HeadlineText } from '@/ui/atoms/headline-text/HeadlineText'

// The images used for low and zero use different heights and widths, so we need to pass them as props
export type LowOrZeroResultsBannerProps = {
  title: string
  description: string
  image: StaticImageData
  imageHeight: number
  imageWidth: number
}

export const LowOrZeroResultsBanner = ({
  title,
  description,
  image,
  imageHeight,
  imageWidth,
}: LowOrZeroResultsBannerProps) => {
  const { colors, spacing } = useTheme()
  return (
    <LowOrZeroResultsBannerContainer
      $isFullWidth={true}
      $alignItems="flex-start"
      data-testid="low-or-zero-results-banner"
    >
      <Flex alignItems="center" justifyContent="flex-start">
        <ImageCustom alt="" srcImage={image} height={imageHeight} width={imageWidth} />
        <Flex flexDirection="column" gap={spacing.defaultSmall}>
          <HeadlineText
            size={{ small: 'small', mediumSmall: 'large' }}
            as="h2"
            color={colors.grey.primary}
            weight={{ small: 'medium', large: 'semiBold' }}
          >
            {title}
          </HeadlineText>
          <BodyText size="small" color={colors.grey.primary}>
            {description}
          </BodyText>
        </Flex>
      </Flex>
    </LowOrZeroResultsBannerContainer>
  )
}
